import { createContext, ReactNode, useContext } from "react";
import { AllTokens } from "gql/graphql";
import { useAbility } from "@/shared/security";

const DataEntryRestrictionContext = createContext<null | ReturnType<
  typeof useAbility
>>(null);

export type DataEntryRestrictionChildrenType =
  | ReactNode
  | ((props: ReturnType<typeof useAbility>) => ReactNode);

export function DataEntryRestriction({
  children,
  influencedBy,
}: {
  children: DataEntryRestrictionChildrenType;
  influencedBy: AllTokens[];
}) {
  const abilities = useAbility(influencedBy);

  return (
    <DataEntryRestrictionValue abilities={abilities}>
      {children}
    </DataEntryRestrictionValue>
  );
}

/**
 * Ограничение полей с уже готовым ответом. Нужно там, где уровень взять неоткуда и решение
 * принимается иначе, — например в форме создания, у которой записи ещё нет. Такое отступление
 * объявляется в своём модуле, чтобы его было видно на месте, а не общим флагом здесь.
 */
export function DataEntryRestrictionValue({
  children,
  abilities,
}: {
  children: DataEntryRestrictionChildrenType;
  abilities: ReturnType<typeof useAbility>;
}) {
  return (
    <DataEntryRestrictionContext.Provider value={abilities}>
      {typeof children === "function" ? children(abilities) : children}
    </DataEntryRestrictionContext.Provider>
  );
}

export function useDataEntryRestriction() {
  const ctx = useContext(DataEntryRestrictionContext);

  if (ctx === null) {
    return {
      canRead: true,
      canModify: true,
      notAvailable: false,
    };
  }

  return ctx;
}
